import { createSlice } from "@reduxjs/toolkit";
import { RootGlobalState } from "../stores/global";

interface PageCard {
  title: string;
  body: string;
}
interface ImagesData {
  left: string;
  right: string;
}
export interface SiteLoadedSettings {
  Intro?: {
    title: string;
    body: string;
  };
  Policy?: {
    title: string;
    body: string;
  };
  Feedback?: {
    external: string | boolean;
    goto: string;
    params: string[];
  };
  Loading?: {
    texts: string[];
  };
}
export interface SiteSettings {
  pages: { [key: string]: PageCard | any };
  questionFile?: string;
  siteFile?: string;
  site_settings: SiteLoadedSettings;
  saveUser: boolean;
  isOneTime: boolean;
  images?: ImagesData;
  oneTimeId: string;
}
const initialState: SiteSettings = {
  pages: {},
  site_settings: {},
  saveUser: true,
  isOneTime: false,
  oneTimeId: "",
  siteFile:
    localStorage.getItem("last-site") !== null
      ? (localStorage.getItem("last-site") as string)
      : undefined,
};

export const GlobalSlice = createSlice({
  name: "SiteSettings",
  initialState,
  reducers: {
    setPages(
      state: SiteSettings,
      action: { payload: { [key: string]: PageCard } }
    ) {
      Object.keys(action.payload).forEach((key) => {
        state.pages[key] = action.payload[key];
      });
    },
    setQuestionsFile(state: SiteSettings, action: { payload: string }) {
      state.questionFile = action.payload;
    },
    setSiteSourceFile(
      state: SiteSettings,
      action: { payload: string | undefined }
    ) {
      state.siteFile = action.payload;
      if (action.payload) localStorage.setItem("last-site", action.payload);
      else localStorage.removeItem("last-site");
    },
    setLoadedSettings(
      state: SiteSettings,
      action: { payload: SiteLoadedSettings }
    ) {
      state.site_settings["Feedback"] = action.payload.Feedback;
      state.site_settings["Intro"] = action.payload.Intro;
      state.site_settings["Policy"] = action.payload.Policy;
    },
    setImages(state: SiteSettings, action: { payload: ImagesData }) {
      state.images = action.payload;
    },
    setIsOneTime(state: SiteSettings, action: { payload: boolean }) {
      state.isOneTime = action.payload;
    },
    setOneTimeID(state: SiteSettings, action: { payload: string }) {
      state.oneTimeId = action.payload;
    },
  },
});
export const {
  setPages,
  setOneTimeID,
  setQuestionsFile,
  setSiteSourceFile,
  setLoadedSettings,
  setImages,
  setIsOneTime,
} = GlobalSlice.actions;
export const selectPages = (state: RootGlobalState) => state.siteInfo;
export const selectSiteSettings = (state: RootGlobalState) =>
  state.siteInfo.site_settings;
export const selectQuestionFile = (state: RootGlobalState) =>
  state.siteInfo.questionFile;
export const selectSiteFile = (state: RootGlobalState) =>
  state.siteInfo.siteFile;
export const selectSiteImages = (state: RootGlobalState) =>
  state.siteInfo.images;
export const selectIsOneTime = (state: RootGlobalState) =>
  state.siteInfo.isOneTime;
export const selectOneTimeID = (state: RootGlobalState) =>
  state.siteInfo.oneTimeId;
export const selectPage = (page?: string) => {
  if (page) return (state: RootGlobalState) => state.siteInfo.pages[page];
  return (state: RootGlobalState) => undefined;
};
export default GlobalSlice.reducer;
